import i18next, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources } from './locales';

export const initI18n = async () => {
  const i18nConfig: InitOptions = {
    resources,
    fallbackLng: 'no',
    supportedLngs: ['no', 'en'],
    defaultNS: 'common',
    ns: [
      'common',
      'global',
      'navigation',
      'notification',
      'type',
      'validation',
      'rentalObjects',
      'reporting',
      'account',
      'agreements',
      'app',
      'tenants',
      'portfolio',
      'products',
      'dashboard',
      'economy',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  };

  await i18next.use(LanguageDetector).use(initReactI18next).init(i18nConfig);
};

export default i18next;
